import { render } from "./courseInfo.vue?vue&type=template&id=2cabf88a&scoped=true"
import script from "./courseInfo.vue?vue&type=script&lang=js"
export * from "./courseInfo.vue?vue&type=script&lang=js"

import "./courseInfo.vue?vue&type=style&index=0&id=2cabf88a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cabf88a"]])

export default __exports__